// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"8ea2c88d","454":"f22b83cc","655":"aacff87f","787":"e37f0fd9"}[chunkId] + ".chunk.js";
};